/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m18.6946 6.0702-7.5-4.2857a1.4 1.4 0 0 0-1.3892 0l-7.5 4.2857A1.4 1.4 0 0 0 1.6 7.2857v8.5181c0 .5024.2692.9663.7054 1.2155l7.5 4.2857c.4304.246.9588.246 1.3892 0l.2144-.1225-.4013-.2235C10.3846 20.612 10 19.9663 10 19.2669v-5.5338c0-.6994.3846-1.3451 1.0077-1.6921l5-2.7842a2.0456 2.0456 0 0 1 1.9846 0l1.4077.7839v-2.755a1.4 1.4 0 0 0-.7054-1.2155ZM21 10.9316V7.2857a3 3 0 0 0-1.5116-2.6047l-7.5-4.2857a3 3 0 0 0-2.9768 0l-7.5 4.2857A3 3 0 0 0 0 7.2857v8.5181a2.9999 2.9999 0 0 0 1.5116 2.6047l7.5 4.2857a2.9996 2.9996 0 0 0 2.9768 0l1.0539-.6022 2.9654 1.6512a2.0456 2.0456 0 0 0 1.9846 0l5-2.7842C23.6154 20.612 24 19.9663 24 19.2669v-5.5338c0-.6994-.3846-1.3451-1.0077-1.6921L21 10.9316Zm-4.2139-.2769a.4457.4457 0 0 1 .4278 0l5 2.7842c.1285.0715.1861.1895.1861.2942v5.5338c0 .1047-.0576.2227-.1861.2942l-5 2.7842a.4457.4457 0 0 1-.4278 0l-5-2.7842c-.1285-.0715-.1861-.1895-.1861-.2942v-5.5338c0-.1047.0576-.2227.1861-.2942l5-2.7842Z"
    clipRule="evenodd"
  />,
  'MenuComponents'
);
